import axiosInstance from "./AxiosInstance";

export function getServiceCallerPrescription(prescriptionData) {
  return axiosInstance.post("/servicecaller/prescriptionList", prescriptionData);
}

export function getServiceCallerprescriptionMarkAsComplete(prescriptionData) {
  return axiosInstance.post("/servicecaller/prescriptionMarkAsComplete", prescriptionData);
}

export function getPatientDetails( patient_id) {
  return axiosInstance.post("/servicecaller/patientDetails", { patient_id});
}

export function reassignPrescriptionService(payload) {
  return axiosInstance.post(
    "/servicecaller/prescriptionReassign",
    payload
  );
}

export function getRepeatPrescriptionList(doctor_id) {
  return axiosInstance.post(
    "/servicecaller/RepeatprescriptionList",
    { doctor_id }
  );
}

export function regeneratePrescription(prescription_id) {
  return axiosInstance.post(
    "/servicecaller/prescriptionRegenerate",
    { prescription_id }
  );
}